export const siteSettings = {
  /** Activar únicamente cuando existan testimonios reales y autorizados. */
  showTestimonials: false,
} as const;

export const siteContent = {
  navigation: {
    ariaLabel: "Navegación principal",
    items: [
      { label: "Método", href: "#metodo" },
      { label: "Sobre mí", href: "#sobre-mi" },
      { label: "FAQ", href: "#faq" },
    ],
    cta: { label: "Quiero empezar mi evolución", href: "/cuestionario" },
    menuOpenLabel: "Abrir menú",
    menuCloseLabel: "Cerrar menú",
  },
  hero: {
    eyebrow: "Nutrición. Entrenamiento. Bienestar.",
    titleLines: ["Tu cambio.", "Tu proceso.", "Tu evolución."],
    text: "Nutrición y entrenamiento para mujeres que quieren perder grasa, mejorar su composición corporal y sentirse fuertes sin vivir a dieta.",
    primaryCta: {
      label: "Quiero empezar mi evolución",
      href: "/cuestionario",
    },
    secondaryCta: { label: "Descubre el método", href: "#metodo" },
    ctaNote: "¡Vamos a conseguir grandes cosas juntas! ♡",
  },
  forYou: {
    eyebrow: "Tu punto de partida",
    title: "Evolution es para ti si...",
    items: [
      "Entrenas y comes bien, pero sientes que tu esfuerzo no se refleja en el espejo.",
      "Has conseguido resultados antes, pero nunca has conseguido mantenerlos.",
      "Te pasas de estricta de lunes a viernes y el fin de semana sientes que lo echas todo a perder.",
      "Te comparas con otras mujeres y sientes que, aunque hagas las cosas “bien”, tu cuerpo no cambia igual.",
      "Te cuesta ser constante porque sientes que, si no lo haces perfecto, no sirve de nada.",
      "Sientes que cada lunes tienes que empezar de cero.",
    ],
    reinforcement: {
      title: "No necesitas hacerlo perfecto. Necesitas hacerlo sostenible.",
      titleLines: [
        "No necesitas hacerlo perfecto.",
        "Necesitas hacerlo sostenible.",
      ],
      text: "Una estrategia que se adapta a ti, a tus objetivos y a tu vida real.",
      closing: "Eso es Evolution.",
    },
  },
  method: {
    id: "metodo",
    eyebrow: "El método Evolution",
    title: "Un proceso que empieza por escucharte.",
    intro:
      "Sin fórmulas universales ni exigencias imposibles. Partimos de tu realidad para construir una estrategia que tenga sentido para ti.",
    steps: [
      {
        number: "01",
        title: "Agendamos una videollamada inicial para conocer tu punto de partida",
        text: "Tus objetivos, tu contexto y aquello que necesitas cambiar forman el inicio del proceso.",
      },
      {
        number: "02",
        title: "Creamos tu plan",
        text: "Tendrás tu plan en un máximo de 48-72 horas.",
      },
      {
        number: "03",
        title: "Evolucionamos contigo",
        text: "El proceso se acompaña y se adapta para ayudarte a construir algo que puedas mantener.",
      },
    ],
  },
  personalization: {
    eyebrow: "Tu acompañamiento",
    titleLines: ["¿Qué incluye", "Evolution?"],
    benefits: [
      {
        title: "Planificación personalizada",
        text: "Una estrategia creada alrededor de ti.",
      },
      {
        title: "Nutrición flexible",
        text: "Aprende a alimentarte sin vivir a dieta.",
      },
      {
        title: "Entrenamiento adaptado",
        text: "Según tu nivel, objetivos y disponibilidad.",
      },
      {
        title: "Seguimiento y ajustes",
        text: "Revisamos tu evolución aproximadamente cada 15 días y realizamos los ajustes necesarios según tu progreso, necesidades y circunstancias.",
      },
      {
        title: "Comunicación y acompañamiento continuo",
        text: "Contacto vía WhatsApp durante el proceso para resolver dudas y ayudarte a avanzar.",
      },
    ],
    guidesIntro:
      "Y además, tendrás acceso a una colección de guías prácticas para ayudarte durante y después de tu proceso.",
    guides: [
      "Guía para comer fuera de casa",
      "Guía de suplementación",
      "Guía de snacks altos en proteína",
      "Guía de recomendaciones generales",
    ],
    imageNote: "Imagen provisional · Sustituir por /Fotos/training-01.webp",
  },
  featureImage: {
    eyebrow: "El proceso también es aprender a escucharte",
    caption:
      "Crear hábitos sostenibles requiere dirección, paciencia y una estrategia que pueda evolucionar contigo.",
    imageNote: "Fotografía provisional",
  },
  about: {
    id: "sobre-mi",
    eyebrow: "Detrás de Evolution",
    titleLines: ["Hola,", "soy Corina"],
    storyTitle: "Yo también estuve ahí",
    paragraphs: [
      "Soy Corina, dietista-nutricionista especializada en composición corporal y salud de la mujer, y durante mucho tiempo pensé que para conseguir el cuerpo que quería tenía que tenerlo todo bajo control.",
      "Controlar lo que comía. Controlar mis entrenamientos. Controlar cada decisión.",
      "Llegué a un punto en el que, si no cumplía con mi entrenamiento o me salía de mis pautas, sentía que había hecho algo mal. Hasta el punto de empezar a dejar de lado planes y momentos con otras personas por miedo a salirme de lo que consideraba “correcto”.",
      "Este ciclo restrictivo me llevó al extremo contrario: aumentar casi 10 kg en apenas unos meses.",
      "Fue un proceso difícil, pero también fue el proceso que más me ha enseñado.",
      "Porque entendí que el problema no era no tener suficiente fuerza de voluntad. El problema era pensar que cuidarme significaba controlarlo absolutamente todo.",
      "Cuidar de tu cuerpo no debería significar dejar de vivir tu vida.",
      "Hoy sigo entrenando. Sigo cuidando mi alimentación. Sigo teniendo objetivos y queriendo sentirme fuerte.",
      "Pero también me encanta viajar, salir a comer, improvisar un plan y disfrutar de una comida que no estaba prevista.",
      "Y todo esto sin sentir que “estoy rompiendo algo”.",
      "Porque ahora sé que una comida no cambia tu progreso, igual que una comida perfecta tampoco lo construye.",
      "No se trata de hacerlo perfecto. Se trata de encontrar una forma de cuidarte que puedas mantener mientras sigues disfrutando de tu vida.",
      "Por eso nació Evolution.",
      "Porque, al final, no se trata de elegir entre conseguir resultados o disfrutar. Se trata de aprender a hacer ambas cosas.",
      "Eso, para mí, es evolucionar.",
    ],
    imageNote: "Retratos provisionales · Sustituir por fotografías reales",
  },
  qualifications: {
    eyebrow: "Formación y especialización",
    title: "Mis formaciones",
    items: [
      "Grado en Nutrición Humana y Dietética — Universidad de Granada",
      "Máster en Entrenamiento, Nutrición y Salud en la Mujer",
      "Especialización en Nutrición Deportiva",
      "Curso de Entrenador Personal",
    ],
  },
  philosophy: {
    eyebrow: "La filosofía Evolution",
    titleLines: ["No se trata", "de hacer más.", "Se trata de", "hacerlo mejor."],
  },
  testimonials: {
    eyebrow: "Experiencias",
    title: "Evoluciones reales, contadas por sus protagonistas.",
    placeholderNotice:
      "Sección de desarrollo. No activar hasta disponer de testimonios reales y autorizados.",
    items: [
      { quote: "[Testimonio real pendiente]", name: "[Nombre pendiente]" },
      { quote: "[Testimonio real pendiente]", name: "[Nombre pendiente]" },
      { quote: "[Testimonio real pendiente]", name: "[Nombre pendiente]" },
    ],
  },
  faq: {
    id: "faq",
    eyebrow: "Preguntas frecuentes",
    title: "Antes de empezar",
    intro:
      "Aquí encontrarás una primera orientación. Los detalles que dependan de tu caso se valorarán después de conocer tu punto de partida.",
    items: [
      {
        question: "¿El proceso es personalizado?",
        answer:
          "Sí. La planificación parte de tus objetivos, circunstancias, preferencias y disponibilidad.",
      },
      {
        question: "¿Necesito experiencia entrenando?",
        answer:
          "No necesitas partir de un nivel concreto. El cuestionario nos ayuda a conocer tu situación para valorar un punto de partida adecuado.",
      },
      {
        question: "¿Cómo sé qué duración necesito?",
        answer:
          "La duración más adecuada depende de tu objetivo y contexto. Podrás indicar tus preferencias en el cuestionario; la información comercial definitiva está pendiente de completar.",
      },
      {
        question: "¿Se adapta a mis horarios?",
        answer:
          "La propuesta nace con la intención de adaptarse a tu disponibilidad real. Los detalles concretos se definirán al valorar tu caso.",
      },
      {
        question: "¿Cómo empiezo?",
        answer:
          "Completa el cuestionario inicial para contar dónde estás y qué quieres conseguir. Enviar la solicitud no implica una contratación automática.",
      },
    ],
  },
  cta: {
    eyebrow: "Tu siguiente paso",
    titleLines: ["¿Lista para", "empezar tu", "evolución?"],
    text: "Cuéntame dónde estás ahora y qué quieres conseguir.",
    button: {
      label: "Quiero empezar mi evolución",
      href: "/cuestionario",
    },
    note: "Completa el cuestionario en menos de 2 minutos.",
  },
  footer: {
    tagline: "Nutrición y entrenamiento adaptados a ti y a tu vida.",
    navigationLabel: "Navegación del pie de página",
    links: [
      { label: "Método", href: "#metodo" },
      { label: "Sobre mí", href: "#sobre-mi" },
      { label: "FAQ", href: "#faq" },
      { label: "Política de privacidad", href: "/privacidad" },
      { label: "Aviso legal", href: "/aviso-legal" },
    ],
    socialLabel: "Instagram pendiente de confirmar",
    legalNote: "Contenido de marketing provisional pendiente de aprobación.",
  },
} as const;
